import { metaKey } from '~/scripts/utils';

export default async ({ route, store }) => {
  const steps = ['life1', 'declaration'];
  if (store.getters['search/get'].additional_person) {
    steps.splice(1, 0, 'life2');
  }
  const currentStep = metaKey(route, 'formStep');
  const stepIndex = steps.indexOf(currentStep);
  const formSteps = [];
  steps.forEach((step, i) => {
    const h = {};
    h.active = i <= stepIndex;
    h.step = step;
    h.text = store.$i18n.t(`forms.steps.${step}`);
    formSteps.push(h);
  });
  store.commit('pageContent/setFormStep', currentStep);
  store.commit('pageContent/setFormSteps', formSteps);
};
